var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#E5122E",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.38 2.72-14 6.22A4.017 4.017 0 0 0 6 12.6V22c0 11.1 7.68 21.48 18 24 10.32-2.52 18-12.9 18-24v-9.4c0-1.58-.94-3.02-2.38-3.66l-14-6.22a3.976 3.976 0 0 0-3.24 0Zm-3.8 29.86L13.4 27.4c-.78-.78-.78-2.04 0-2.82.78-.78 2.04-.78 2.82 0L20 28.34l11.76-11.76c.78-.78 2.04-.78 2.82 0 .78.78.78 2.04 0 2.82L21.4 32.58c-.76.78-2.04.78-2.82 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0949a3e821dfaa8d3ce55ea7cd76cf0a.svg";
export { ForwardRef as ReactComponent };